
(function () {
    'use strict';
    angular.module('tmx-common')
    //////////////////////////       DIRECTIVE         ////////////////////////////////////////////////////
        .directive('errorMsg', function(errorMsgObj){


            var linkFunction = function(scope, element, attributes) {
                 
                scope.fieldName = attributes["fieldName"];
                scope.fieldUserFriendlyName = attributes["fieldUserFriendlyName"];
                scope.type = attributes["inputType"];
                scope.patternMessage = "";
                scope.passMsg= "";


                if(angular.isDefined(scope.fieldUserFriendlyName)) {
                    scope.fieldName = scope.fieldUserFriendlyName ;
                }

                scope.fieldName = scope.fieldName.replace(/([A-Z])/g, ' $1').trim()
                var type = scope.type;

                if(type=="password"){
                    scope.patternMessage  = errorMsgObj.passwordMsg;
                }
                else if(type=="AN"){
                    scope.patternMessage  = errorMsgObj.alphabetNumericMsg;
                }
                else {
                    scope.patternMessage  = scope.fieldName +" is invalid";
                }

            };
            return {
                restrict: 'E',
                require: 'ngMessages',
                templateUrl: 'common/directives/errorClientSideDirective/errorMsg.html',
                link: linkFunction,
                scope:{
                    form:"=",
                    fieldName:"@",
                    inputType:"@",
                    ngMessages:"="
                },
                controller: ['errorMsgObj','$scope',function (errorMsgObj,$scope) {
                    this.msgObj = errorMsgObj;
                    var errorCtrl=this;

               //////////////////////// FOR FUTURE USE (do not delete)////////////////////////////////////////////////
                    $scope.invalidPhone = true;
                    $scope.CNIC = false;
                    if($scope.fieldName=="CNIC"){
                        $scope.CNIC = true;
                        $scope.invalidPhone=false;
                    }
                // 
                //
                //function getphoneValue(){
                //    var Value;
                //    if(angular.isDefined($scope.form[$scope.fieldName]) && $scope.inputType == "phone" ){
                //        Value = $scope.form[$scope.fieldName].$viewValue;
                //        Value = Value.split(" ");
                //        Value = Value[0];
                //        return Value.length;
                //    }
                //    else{
                //        return 0;
                //    }
                //}
                //errorCtrl.onchange = function(newvalue,oldvalue){
                //
                //    if(!angular.isDefined($scope.form[$scope.fieldName])){return;}
                //    if($scope.inputType == "phone"){
                //        if(angular.isDefined($scope.form)){
                //            $scope.invalidPhone = false;
                //            if(newvalue >9 && newvalue <13){
                //                $scope.form[$scope.fieldName].$invalid = true;
                //                $scope.form[$scope.fieldName].$error={"mask":true};
                //                $scope.invalidPhone = true;
                //
                //            }
                //        }
                //    }
                //};
                //$scope.$watch(getphoneValue,errorCtrl.onchange);
                //////////////////////// FOR FUTURE USE (do not delete)////////////////////////////////////////////////
                }],
                controllerAs: 'errorCtrl'

            }

        })


    ////////////////////////////       CONSTANTS         ////////////////////////////////////

        .constant('userInputRestrictions' , {
            'size': "30",
            'minlen': "3",
            'maxlen': "25",
            'passwordLen': "8"

        })
    ////////////////////////////       SERVICES         ////////////////////////////////////
        .factory('errorMsgObj',['userInputRestrictions', function(userInputRestrictions){
            var errorMessages =  {
                requiredMsg:"This is a Required Field!",
                alphabetMsg: "Only alphabets are allowed",
                alphabetNumericMsg: "Only alphabets and numbers are allowed",
                minlenMsg: "Field must be at-least " + eval('userInputRestrictions.minlen') + " characters!",
                maxlenMsg: "Field must be less than " + eval('userInputRestrictions.maxlen') + " characters!",
                passwordMsg: "Must be at least 8 characters long and must contain at least one lowercase letter, one uppercase letter, one number and one special character.",

            };
            return errorMessages;

        }]);


})();